import { FC, useMemo, useState } from "react";

import { useBandContext } from "Bands/contexts";
import { BAND_PATHS } from "Bands/router";
import { IEvent, IIconBandSetting } from "Bands/types";
import { useBandRegionalSettings, useBandRoute } from "Bands/utils";
import { FormBuilder } from "shared/components";
import { API_ENDPOINTS } from "shared/constants";
import { IAPIError, IAPIState, IFormButtons } from "shared/types";
import { getFields } from "./formData";

interface EventFormProps {
  apiStatus?: IAPIState;
  hasError?: boolean;
  defaultValues?: Record<string, any>;
  buttons?: IFormButtons;
  eventTypes: IIconBandSetting[];
  apiError?: IAPIError | null;
  handleSubmit: (stage: IEvent) => void;
  placeholder: Partial<IEvent>;
  updatePlaceholder: (event: Partial<IEvent>) => void;
  canManageTypes?: boolean;
  setDate?: (v: string) => void;
}

export const EventForm: FC<EventFormProps> = ({
  apiStatus,
  hasError,
  eventTypes,
  placeholder,
  updatePlaceholder,
  handleSubmit,
  defaultValues,
  canManageTypes = false,
  setDate,
  ...rest
}) => {
  const { pushRoute } = useBandRoute();

  const { dateFormat, timeFormat } = useBandRegionalSettings();
  const { bandId } = useBandContext();

  // TODO: This is a hack to get the simpleTimefield to work with the form.
  const [time, setTime] = useState("");

  const fields = useMemo(
    () =>
      getFields({
        eventTypes,
        manageEventTypes: () => pushRoute(BAND_PATHS.EDIT_BAND_SETTINGS_EVENT),
        timeFormat,
        dateFormat,
        canManageTypes,
        placeholder,
        updatePlaceholder,
        setTime,
        setDate,
      }),
    [
      eventTypes,
      timeFormat,
      dateFormat,
      pushRoute,
      canManageTypes,
      placeholder,
      setDate,
      updatePlaceholder,
    ]
  );

  const onSubmit = (data: IEvent) => {
    const band = API_ENDPOINTS.BAND(bandId || "");

    if (!time) {
      handleSubmit({ ...data, band });
    } else {
      handleSubmit({ ...data, time, band });
    }
  };

  return (
    <FormBuilder
      fields={fields}
      isSubmitting={apiStatus === IAPIState.pending}
      onBlur={updatePlaceholder}
      apiErrorMessage={hasError}
      onSubmit={onSubmit}
      style={{
        gridTemplateColumns: "2fr 2fr 3fr",
      }}
      defaultValues={defaultValues}
      dataTestId="event_form"
      {...rest}
    />
  );
};
